/**
 * @generated SignedSource<<eebfeb1282376bd12b25c66c9e3eb7fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternDashboardQuery$variables = {};
export type InternDashboardQuery$data = {
  readonly internJobHealthMetrics: {
    readonly " $fragmentSpreads": FragmentRefs<"InternJobsHealthCard_metrics">;
  };
  readonly internPlatformMetrics: {
    readonly activeBrands: number;
    readonly alerts: ReadonlyArray<{
      readonly alertType: string;
      readonly brandIds: ReadonlyArray<string>;
      readonly count: number;
      readonly message: string;
      readonly severity: string;
      readonly title: string;
    }>;
    readonly brandStatusCounts: ReadonlyArray<{
      readonly count: number;
      readonly label: string;
      readonly status: string;
    }>;
    readonly totalAppOrders30d: number;
    readonly totalAppSales30d: number;
    readonly totalAppSessions30d: number;
    readonly totalAppUsers: number;
    readonly totalBrands: number;
    readonly trends: ReadonlyArray<{
      readonly appOrders: number;
      readonly appSales: number;
      readonly appSessions: number;
      readonly date: string;
      readonly newAppUsers: number;
    }>;
  };
  readonly internPushNotificationStatus: {
    readonly " $fragmentSpreads": FragmentRefs<"InternPushStatusCard_status">;
  };
};
export type InternDashboardQuery = {
  response: InternDashboardQuery$data;
  variables: InternDashboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PlatformMetricsSummary",
  "kind": "LinkedField",
  "name": "internPlatformMetrics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalBrands",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeBrands",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalAppUsers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalAppSessions30d",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalAppSales30d",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalAppOrders30d",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandStatusCount",
      "kind": "LinkedField",
      "name": "brandStatusCounts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PlatformMetricsTrend",
      "kind": "LinkedField",
      "name": "trends",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appSessions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appSales",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appOrders",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newAppUsers",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PlatformAlert",
      "kind": "LinkedField",
      "name": "alerts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alertType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "severity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "brandIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InternDashboardQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "PlatformPushNotificationStatus",
        "kind": "LinkedField",
        "name": "internPushNotificationStatus",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternPushStatusCard_status"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobHealthMetrics",
        "kind": "LinkedField",
        "name": "internJobHealthMetrics",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternJobsHealthCard_metrics"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InternDashboardQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "PlatformPushNotificationStatus",
        "kind": "LinkedField",
        "name": "internPushNotificationStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "azureApiConnected",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "azureApiError",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationHubConnected",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationHubError",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationsSent30d",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pushDeliveries30d",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pushTaps30d",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tapRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRegisteredDevices",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iosDevices",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "androidDevices",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalActiveBrands",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandsWithHub",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandsWithIosCredentials",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandsWithAndroidCredentials",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandsNeedingIosMigration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandsNeedingAndroidMigration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PushNotificationDailyMetric",
            "kind": "LinkedField",
            "name": "dailyMetrics",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deliveries",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taps",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobHealthMetrics",
        "kind": "LinkedField",
        "name": "internJobHealthMetrics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalJobs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "successCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failureCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "runningCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "retryCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "successRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "avgDurationMs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobsLastHour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failuresLastHour",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "69a18df8bcc7d4aaf7b342fa8bf91fbe",
    "id": null,
    "metadata": {},
    "name": "InternDashboardQuery",
    "operationKind": "query",
    "text": "query InternDashboardQuery {\n  internPlatformMetrics {\n    totalBrands\n    activeBrands\n    totalAppUsers\n    totalAppSessions30d\n    totalAppSales30d\n    totalAppOrders30d\n    brandStatusCounts {\n      status\n      count\n      label\n    }\n    trends {\n      date\n      appSessions\n      appSales\n      appOrders\n      newAppUsers\n    }\n    alerts {\n      alertType\n      title\n      message\n      count\n      severity\n      brandIds\n    }\n  }\n  internPushNotificationStatus {\n    ...InternPushStatusCard_status\n  }\n  internJobHealthMetrics {\n    ...InternJobsHealthCard_metrics\n  }\n}\n\nfragment InternJobsHealthCard_metrics on JobHealthMetrics {\n  totalJobs\n  successCount\n  failureCount\n  runningCount\n  retryCount\n  successRate\n  avgDurationMs\n  jobsLastHour\n  failuresLastHour\n}\n\nfragment InternPushStatusCard_status on PlatformPushNotificationStatus {\n  azureApiConnected\n  azureApiError\n  notificationHubConnected\n  notificationHubError\n  notificationsSent30d\n  pushDeliveries30d\n  pushTaps30d\n  tapRate\n  totalRegisteredDevices\n  iosDevices\n  androidDevices\n  totalActiveBrands\n  brandsWithHub\n  brandsWithIosCredentials\n  brandsWithAndroidCredentials\n  brandsNeedingIosMigration\n  brandsNeedingAndroidMigration\n  dailyMetrics {\n    date\n    deliveries\n    taps\n  }\n}\n"
  }
};
})();

(node as any).hash = "1f292075179f69158b6b53e88672c109";

export default node;
